<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name" id="benefitHeader">{{pageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="forms-container">
                    <div class="row no-margin">
                        <!-- Title -->
                        <div class="col-12 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label" for="dayForceId">Title :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input @input="titleError = ''" maxlength="190" v-model="title" type="text" class="form-control" id="dayForceId" placeholder="Title">
                                <div class="requiredstar">*</div>
                                <font class="text-danger">{{titleError}}</font>
                            </div>
                        </div>
                        <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="roleData">Folder :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="folderId"
                                                  @change="changedValue"
                                                  @input="changedValueUser()"
                                                  name="folderId"
                                                  id="folderData"
                                                  label="name"
                                                  :filterable="false"
                                                  :options="reportToArr"
                                                  @search="onSearchFolder"
                                                  placeholder="Select Folder">
                                            <template slot="no-options">
                                                Search Folder...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{folderError}}</font>
                                </div>
                            </div>
                        <div class="col-12 forms-block" id="pro_pic_id">
                            <div class="col-3 paddingleft0">
                                <div class="form-label" for="drop1">Document :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <!-- <vue-dropzone
                                    id="drop1"
                                    :options="dropzoneOptions"
                                    ref="dropzone"
                                    :destroyDropzone="false"
                                    :headers="dropzoneOptions.headers"
                                    @vdropzone-removed-file="removedSelectedFile"
                                    @vdropzone-success="vfileSuccess"
                                    @vdropzone-duplicate-file="vduplicateFile"
                                    name="file"
                                    >
                                </vue-dropzone> -->
                                <vue-dropzone
                                    id="drop1"
                                    :options="dropzoneOptions"
                                    ref="dropzone"
                                    :destroyDropzone="false"
                                    :headers="dropzoneOptions.headers"
                                    @vdropzone-removed-file="removedSelectedFile"
                                    @vdropzone-success="vfileSuccess"
                                    name="file"
                                    >
                                </vue-dropzone>
                                <font class="text-danger">{{imageError}}</font>
                                <font class="text-danger"> <strong id="errorMsg2" class="error text-danger"></strong></font>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                    </div>
                    <div class="row clearfix" >
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="alert alert-danger" id="alertError">
                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                            <strong id="errorMsg" class="error"></strong>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>

                <!--Buttons-->
                <div class="row clearfix"></div>
                <div class="button-demo">
                    <input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdateManagerToolBox()">
                    <input id="addAndContinueBenifitBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addUpdateManagerToolBox(flag='Save and Continue')">
                    <input id="CancelBenifit" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                </div>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import BackendFooter from '@/components/backend/partials/Footer';
    import Vue from 'vue';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';

    import VueCroppie from 'vue-croppie';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';


    import EventBus from '../../event-bus';

    export default {
        name: 'AddBenefits',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            'app-backend-footer': BackendFooter,
            vueDropzone: vue2Dropzone,
        },
        data() {
            return {
                pageTitle: 'Add Document',
                title: '',
                titleError: '',
                dropzoneOptions: {
                    url: process.env.ROOT_API + "/uploadmedia",
                    timeout: 3000000,
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 10, //MB
                    maxFiles: 1,
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    acceptedFiles: ".jpg, .png, .jpeg, .pdf, .docx, .doc",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },
                imageType: '',
                imageSize: '',
                imagePath: '',
                imageWidth: 0,
                imageHeight: 0,
                imageError: '',
                isFileUploaded: false,
                editId: 0,
                folderId: 0,
                folderError: '',
                reportToArr:[]
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            //self.checkLogin();
        },
        mounted: function () {
            $("#alertError").hide();
            if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                self.editId = self.$route.params.id;
                self.getManagerToolBoxDetailsById();
                $("#addAndContinueBenifitBtn").hide();
                $("#addBenifitBtn").val("Update");
                self.pageTitle = "Edit Document";
            }
            self.loadFolders();
        },
        methods: {
            changedValue: function (value) {
                // console.log(value);
            },
            changedValueUser: function () {
                self.folderError = "";
            },
            onSearchFolder(search, loading) {
                let self = this;
                /*if (self.siteid != null && self.siteid != "") {*/
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    self.loadFolders(loading, search, this);
                }
                /*}*/
            },
            buttonBack() {
                self.$router.push('/backend/listmanagertoolbox');
            },
            removeAllFiles() {
                self.$refs.dropzone.removeAllFiles();
                self.isFileUploaded = false;
            },
            vfileSuccess: function (file, response) {
                self.imagePath = response.content.media_path;
                self.isFileUploaded = true;
                if ("media_thumb_path" in response.content) {
                    self.mediaThumbnailPaths = response.content.media_thumb_path;
                } else {
                    self.mediaThumbnailPaths.push("");
                    /*console.log("No media thumb");*/
                }
                self.imageType = file.type;
                self.imageSize = file.size;
                self.imageWidth = file.width;
                self.imageHeight = file.height;
                self.imageError = '';
                /* if (self.isFileUploaded == true && self.imageHeight % 225 != 0 || !(self.imageHeight >= 225) || !(self.imageHeight <= 450)
                        || self.imageWidth % 600 != 0 || !(self.imageWidth >= 600) || !(self.imageWidth <= 1200)) {
                    self.removeAllFiles();
                    self.imageError = "Please Upload Image In This Dimensions Only.(Height : 450 pixel, Width 1200 pixel)";
                } */
            },
            removedSelectedFile(file, xhr, error) {
                if(file.accepted || file.manuallyAdded) {
                    self.isFileUploaded = false;
                    self.imagePath = '';
                }
                self.imageHeight = 0;
                self.imageWidth = 0;
                var filePath = JSON.parse(file.xhr.response);
                //console.log(file);
                if ("media_thumb_path" in filePath.content) {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                } else {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, "");
                }
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            vduplicateFile: function (file) { // Todo: Understand functionality. Not Working till date.
                /*console.log("Duplicate file" + file.name);*/
            },
            getManagerToolBoxDetailsById: function() {
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                    params : {
                        id : self.editId
                    }
                };
                HTTP.get('/managertoolbox/get', config)
                    .then(function (response) {
                        self.title = response.data.content.title;
                        self.imagePath = response.data.content.document;
                        if (self.imagePath != '') {
                                self.isFileUploaded = true;
                                self.folderId = {
                                    id: response.data.content.folder_id, 
                                    text: response.data.content.folder_name,
                                    name: response.data.content.folder_name,
                                    value: response.data.content.id
                                };
                                
                                self.imageSize = response.data.content.document_size;
                                self.imageWidth = 1200;
                                self.imageHeight = 450;
                                self.uploadManually();
                                // self.imagePath = '';
                            }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            uploadManually(file) {
                if (self.imagePath != '') {
                    var file_name = self.getFileName(self.imagePath);
                    let file_type = self.getFileType(file_name);
                    let url = self.imagePath;
                    let file_size = self.imageSize;
                    /*console.log("File Name : " + file_name + " , File Type : " + file_type + " , URL : " + url + " , File Size : " + file_size);*/
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                    /*
                     self.truckFormData.uploadedFiles.push(file_name);*/
                }
            },
            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                if(file_type.includes('pdf') || file_type.includes('doc') || file_type.includes('docx')){
                    return 'application/' + file_type;
                }
                return 'image/' + file_type;
            },
            checkForm: function() {
                var checked = true;
                self.titleError = '';
                self.imageError = '';

                if(!self.title) {
                    self.titleError = "Title Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.isFileUploaded == false) {
                    self.imageError = "Please Upload Document";
                    if (checked) {
                        checked = false;
                    }
                }

                if(self.folderId == 0){
                    self.folderError = "Please Select Folder";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            addUpdateManagerToolBox: function (flag) {
                if(self.checkForm()) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var data = {
                        folder_id: self.folderId.id,
                        title: self.title,
                        mediaPath: self.imagePath,
                        mediaType: self.imageType,
                        mediaSize: self.imageSize,
                        id: self.editId,
                    };
                    if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                        $("#addBenifitBtn").val("Updating ...");
                        $("#addBenifitBtn").prop("disabled", true);
                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                        $("#CancelBenifit").prop("disabled", true);
                    } else {
                        if (flag == "Save and Continue") {
                            $("#addAndContinueBenifitBtn").val("Saving ...");
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            $("#addBenifitBtn").val("Saving ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        }
                    }
                    HTTP.post("/managertoolbox/add/update", data, config)
                        .then(function (response) {
                            self.removeAllFiles();
                            if (typeof(self.$route.params.id) != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                                $("#addBenifitBtn").val("Update");
                                $("#addBenifitBtn").prop("disabled", false);
                                $("#CancelBenifit").prop("disabled", false);
                            } else {
                                if (flag == "Save and Continue") {
                                    $("#addAndContinueBenifitBtn").val("Save and Continue");
                                    $("#addAndContinueBenifitBtn").prop("disabled", false);
                                    $("#addBenifitBtn").prop("disabled", false);
                                    $("#CancelBenifit").prop("disabled", false);
                                } else {
                                    $("#addBenifitBtn").val("Save");
                                    $("#addBenifitBtn").prop("disabled", false);
                                    $("#addAndContinueBenifitBtn").prop("disabled", false);
                                    $("#CancelBenifit").prop("disabled", false);
                                }
                            }
                            if (response.data.status == "success") {
                                // self.$router.push('/task/list');
                                $("#errorMsg").html(response.data.content);
                                $(".alert-danger").removeClass("hide");
                                $(".alert-danger").addClass("show");
                                if (flag == "Save and Continue") {
                                    $(".alert-success").addClass("show");
                                    self.title = '';
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 3000);
                                } else {
                                    $(".back_button").prop("disabled", true);
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                        self.buttonBack();
                                    }, 3000);
                                }
                            } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                        })
                        .catch(function (err) {
                            self.removeAllFiles();
                            if (typeof(self.$route.params.id) != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                                $("#addBenifitBtn").val("Update");
                                $("#addBenifitBtn").prop("disabled", false);
                                // $("#addAndContinueCaseBtn").prop('disabled',true);
                                $("#CancelBenifit").prop("disabled", false);
                                $("#errorMsg").html(err.response.data.message);
                                $(".alert-danger").removeClass("hide");
                                $(".alert-danger").addClass("show");
                                setTimeout(function () {
                                    $(".alert-danger").removeClass("show");
                                    $(".alert-danger").addClass("hide");
                                }, 5000);
                            } else {
                                if (flag == "Save and Continue") {
                                    $("#addAndContinueBenifitBtn").prop("disabled", false);
                                    $("#addAndContinueBenifitBtn").val("Save and Continue");
                                    $("#addBenifitBtn").prop("disabled", false);
                                    $("#CancelBenifit").prop("disabled", false);
                                    $("#errorMsg").html(err.response.data.message);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    $(".alert-success").removeClass("hide");
                                    $(".alert-success").addClass("show");
                                    self.title = '';
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                } else {
                                    $("#addBenifitBtn").val("Save");
                                    $("#addBenifitBtn").prop("disabled", false);
                                    $("#addAndContinueBenifitBtn").prop("disabled", true);
                                    $("#CancelBenifit").prop("disabled", false);
                                    $("#errorMsg").html(err.response.data.message);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                            }
                            if (err.response.status == 0) {
                                self.errorMsg = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                $("#errorMsg").html(err.response.data.message);
                                $(".alert-danger").removeClass("hide");
                                $(".alert-danger").addClass("show");
                                setTimeout(function () {
                                    $(".alert-danger").removeClass("show");
                                    $(".alert-danger").addClass("hide");
                                }, 5000);
                            }
                        });
                }
            },
            
            loadFolders(loading, search, vm) {
                let self = this;
                var siteId = "";
                var departmentId = "";
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        search: search,
                    }
                };
                /* var fields = {
                    search: search,
                    except_self : 1,
                }; */
                HTTP.get("getfolder", config)
                        .then(function (response) {
                            self.reportToArr = [];
                            $.each(response.data.content, function (i) {
                                self.reportToArr.push(response.data.content[i]);
                            });
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                // redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/backend/ManagerToolBox/AddUpdateManagerToolBox.vue